import * as tslib_1 from "tslib";
import { CredentialStoreGenericType, CredentialStoreResourceType, } from '@models';
import { AssetCredentialStoreResourcesSource } from '@pages/credential-stores/grid/asset-credential-store-resources.grid';
import { RobotCredentialStoreResourcesSource } from '@pages/credential-stores/grid/robot-credential-store-resources.grid';
import { CredentialStoreDeleteModalComponent } from '@pages/credential-stores/modal/credential-store-delete/credential-store-delete.modal';
import { CredentialStoreModalComponent } from '@pages/credential-stores/modal/credential-store/credential-store.modal';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { CredentialStoresService, ModalService, } from '@services';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import { BehaviorSubject, forkJoin, } from 'rxjs';
import { filter, finalize, map, switchMap, switchMapTo, takeUntil, } from 'rxjs/operators';
var CredentialStoresSource = /** @class */ (function () {
    function CredentialStoresSource(_credentialStore) {
        this._credentialStore = _credentialStore;
    }
    Object.defineProperty(CredentialStoresSource.prototype, "mapper", {
        get: function () {
            return this._credentialStore.mapper;
        },
        enumerable: true,
        configurable: true
    });
    CredentialStoresSource.prototype.get = function (qo) {
        return forkJoin({
            credentialStores: this._credentialStore.get(qo),
            robotsDefaultStoreId: this._credentialStore.getDefaultStore(CredentialStoreResourceType.RobotCredential),
            assetsDefaultStoreId: this._credentialStore.getDefaultStore(CredentialStoreResourceType.AssetCredential),
        })
            .pipe(map(function (_a) {
            var credentialStores = _a.credentialStores, robotsDefaultStoreId = _a.robotsDefaultStoreId, assetsDefaultStoreId = _a.assetsDefaultStoreId;
            credentialStores.data = credentialStores.data
                .map(function (credentialStore) { return (tslib_1.__assign({}, credentialStore, { isRobotDefault: robotsDefaultStoreId === credentialStore.id, isAssetDefault: assetsDefaultStoreId === credentialStore.id })); });
            return credentialStores;
        }));
    };
    return CredentialStoresSource;
}());
export { CredentialStoresSource };
var CredentialStoresComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CredentialStoresComponent, _super);
    function CredentialStoresComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CredentialStoreGenericType = CredentialStoreGenericType;
        _this.CredentialStoreResourceType = CredentialStoreResourceType;
        _this.loadingModal$ = new BehaviorSubject(false);
        _this._modalService = _this._injector.get(ModalService);
        _this._credentialStoreService = _this._injector.get(CredentialStoresService);
        _this._assetCredentialStoreResourcesSource = _this._injector.get(AssetCredentialStoreResourcesSource);
        _this._robotCredentialStoreResourcesSource = _this._injector.get(RobotCredentialStoreResourcesSource);
        return _this;
    }
    CredentialStoresComponent.prototype.openModal = function (model) {
        var _this = this;
        this.loadingModal$.next(true);
        var openModal = function (credentialStore) {
            return _this._modalService
                .openModal(CredentialStoreModalComponent, credentialStore)
                .afterClosed();
        };
        (model ?
            this._credentialStoreService
                .getInstance(model.id)
                .pipe(switchMap(openModal)) :
            openModal(null)).pipe(finalize(function () { return _this.loadingModal$.next(false); }), filterNullOrUndefined(), takeUntil(this._destroyed$)).subscribe(function () { return _this._refresh$.next(); });
    };
    CredentialStoresComponent.prototype.setDefaultStore = function (entry, resourceType) {
        var _this = this;
        this.loading$.next(true);
        this._credentialStoreService.setDefaultStore(entry, resourceType)
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function () { return _this._refresh$.next(); }, finalize(function () { return _this.loading$.next(false); }));
    };
    CredentialStoresComponent.prototype.remove = function (entry) {
        var _this = this;
        this._assetCredentialStoreResourcesSource.credentialStore = entry;
        this._robotCredentialStoreResourcesSource.credentialStore = entry;
        forkJoin({
            assets: this._assetCredentialStoreResourcesSource.get({
                top: 1,
            }),
            robots: this._robotCredentialStoreResourcesSource.get({
                top: 1,
            }),
        }).pipe(switchMap(function (result) { return result.robots.total + result.assets.total ?
            _this._modalService
                .openModal(CredentialStoreDeleteModalComponent, entry, {
                data: {
                    robotCount: result.robots.total,
                    assetCount: result.assets.total,
                },
            })
                .afterClosed() :
            _this._modal.onConfirm(null, undefined, undefined, _this._translate.instant('credential_stores_action_remove_confirmation')).pipe(filter(Boolean)); })).pipe(filterNullOrUndefined(), switchMapTo(this._credentialStoreService.deleteCredentialStore(entry))).subscribe(function () { return _this._refresh$.next(); });
    };
    return CredentialStoresComponent;
}(ODataGridComponent));
export { CredentialStoresComponent };
